<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0 justify-content-between d-flex">
        <audio src="../../../../assets/alarm.mp3" id="voice" ref="voice" controls hidden></audio>

        <h5 class="card-title font-bold py-3">مدیریت فروش فروشندگان</h5>
        <div style="flex: 1"></div>
        <button class="btn ml-2" @click="enableSoundPlayback"
          :class="!interactionEnabled ? ' btn-danger' : 'btn-success'">
          <span v-if="interactionEnabled">
            آلارم فعال میباشد
          </span>
          <span v-else>
            آلارم غیر فعال میباشد
          </span>
        </button>
        <router-link to="/admin/change-status-sellers?type=return" class="btn btn-danger ml-2">
          بازگشت کلی تنوع ها
        </router-link>

        <router-link to="/admin/sales-management/reports/result-goods/" class="btn btn-secondary ml-5">
          گزارشات
          <i class="fe fe-bar-chart-2"></i>
        </router-link>

      </div>
      <div class="card-body">
        <div class="row flex-row justify-content-start mb-3 g-3">
          <div class="col-auto" v-for="(seller, index) in sellers" :key="index">
            <div class="report-item-card">
              <router-link type="button" :to="'/admin/sales-management/' + seller.id">
                <span class="report-label">{{ seller.full_name }}</span>

                <span class="counter">{{
                  seller.pending_seller_requests_count
                }}</span>
              </router-link>
            </div>

          </div>
          <!-- 
                    <div class="col-auto" v-for="(seller,index) in sellers" :key="index">
                        <div class="report-item-card">
                            <span class="report-label">{{seller.full_name}}</span>
                            <router-link
                                type="button"
                                :to="'/admin/sales-management/' + seller.id"
                                class="btn btn-dark"
                                >مشاهده جزئیات
                                <span class="bg-dot">{{ seller.pending_seller_requests_count }}</span>
                            </router-link>
                        </div>
                    </div> -->
        </div>
        <Loading v-if="$root.isEmptyObject(sellers)" />
      </div>
    </div>
  </main>
</template>

<script>
import SalesManagementImpl from "@@/core/pages/SalesManagement/SalesManagementList/SalesManagementImpl";
export default {
  extends: SalesManagementImpl,
};
</script>
<style src="@@/core/pages/SalesManagement/SalesManagementList/SalesManagementStyle.css" scoped></style>
